import { FC, ReactNode } from "react";
import styles from "./ThinButton.module.scss";

interface IThinButtonProps {
    caption: ReactNode;
    handler: () => void;
    small?: boolean;
    inverse?: boolean;
}

export const ThinButton: FC<IThinButtonProps> = ({ caption, handler, small = false, inverse = false }) => {
    return (
        <button className={`${styles.button} ${small ? styles.small : ''} ${inverse ? styles.inverse : ''}` } onClick={ handler }>
            { caption }
        </button>
    );
}